
import { Component, Prop, VModel, Mixins } from "vue-property-decorator";

import OrderCustomerTab from "@pazion/pazion-catalog/src/components/dialog/tabs/OrderCustomerTab.vue";
import FulfilmentTab from "@pazion/pazion-catalog/src/components/dialog/tabs/FulfilmentTab.vue";
import AttributesTab from "@pazion/pazion-catalog/src/components/dialog/tabs/AttributesTab.vue";
import OrderItemsTab from "@pazion/pazion-catalog/src/components/dialog/tabs/OrderItemsTab.vue";
import OrderDialogMixin from "@pazion/pazion-catalog/src/components/dialog/mixins/ordersDialogMixin";
import CustomerPicker from "@pazion/pazion-catalog/src/components/picker/CustomerPicker.vue";
import PazAdressPicker from "@pazion/pazion-catalog/src/components/picker/PazAdressPicker.vue";
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazClipboardButton from "@pazion/pazion-core/src/components/controls/PazClipboardButton.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazDateField from "@pazion/pazion-core/src/components/utils/PazDateField.vue";

import { DataTableHeader } from "vuetify";
import type { IFulfilment } from "@pazion/pazion-catalog/src/models/fulfilment";
import type { IOrder, IOrderLine } from "@pazion/pazion-catalog/src/models/order";

import { formatDate, formatDateYMD } from "@pazion/pazion-catalog/src/helpers/format";
import { formatDateTime } from "@pazion/pazion-core/src/services/base-service";
import { formatPrice } from "@pazion/pazion-catalog/src/helpers/format";
import {
  getFulfilment,
  getFulfilmentOrderLines,
  getFulfilmentTransports,
  getOrderLines,
  postOrderDelivery,
  getOrderDetails,
  getFulfilmentStatuses,
  updateFullfilment,
  getPackageSizes,
  updateOrder,
} from "@pazion/pazion-catalog/src/services/catalog-service";

import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import { putRequest } from "@pazion/pazion-core/src/services/auth-service";
import { fieldsByClass } from "@pazion/pazion-core/src/services/settings-fields";
import { authentication } from "@pazion/pazion-core/src/store";

@Component({
  components: {
    PazLoader,
    OrderItemsTab,
    OrderCustomerTab,
    FulfilmentTab,
    AttributesTab,
    CustomerPicker,
    PazTooltipButton,
    PazConfirmation,
    PazDateField,
    PazClipboardButton,
    PazAdressPicker,
  },
  methods: {
    formatDate,
    formatDateYMD,
    formatPrice,
    fieldsByClass,
  },
})
export default class PazOrderDeliveryDialog extends Mixins(
  OrderDialogMixin,
  PermissionService
) {
  $refs!: {
    confirm: PazConfirmation;
  };

  @VModel({
    default: false,
  })
  public showDialog!: boolean;

  @Prop({ default: true })
  public editAble!: boolean;

  @Prop({ default: null })
  public orderId: number | null | undefined;

  @Prop({ default: null })
  public order: IOrder | null | undefined;

  @Prop({ default: false })
  public baseModalInfo?: boolean;

  @Prop()
  public selectedFulfilment?: IFulfilment;

  public orderData = null;
  public orderDate: string = "";
  public preferredDeliveryDate: string = "";

  public FulfilmentStatuses: { fulfilmentStatuses: any } = {
    fulfilmentStatuses: null,
  };

  public headers: DataTableHeader[] = [
    { text: "EAN", align: "start", sortable: false, value: "id" },
    { text: "Description", align: "center", value: "description" },
    { text: "Stock count", align: "center", value: "stockCount" },
    { text: "Shipped", align: "center", value: "shipped" },
    { text: "Ordered", align: "center", value: "max" },
    { text: "Quantity", align: "center", value: "quantity" },
    { text: "Price", align: "center", value: "price" },
  ];
  public fulfilment: IFulfilment | undefined;
  public shipmentHeaders: DataTableHeader[] = [
    {
      text: "EAN",
      align: "start",
      sortable: false,
      value: "orderlineProduct",
      class: "col-2",
    },
    {
      text: "Description",
      align: "start",
      value: "orderLine.description",
      class: "col-8",
    },
    {
      text: "Ordered quantity",
      align: "center",
      value: "orderLine.quantity",
      class: "col-1",
    },
    {
      text: "Quantity",
      align: "center",
      value: "orderLine.quantity",
      class: "col-1",
    },
  ];
  public selected: [] = [];
  public orderLines: IOrderLine[] = [];

  public loading: boolean = false;
  public mainPreLoading: boolean = false;
  public modalDeliveryDatePicker: boolean = false;

  public deliverAt: string = "";

  public packageSize: null = null;
  public packageSizeItems = [];

  get isNewStatus() {
    return this.getFulfilmentStatus === "NEW";
  }

  decrement(item: IOrderLine) {
    if ("newQuantity" in item) {
      item.newQuantity -= 1;
      this.quantityWarnMessage(item);
    }
  }

  increment(item: IOrderLine) {
    if ("newQuantity" in item) {
      item.newQuantity += 1;
      this.quantityWarnMessage(item);
    }
  }

  fieldByType(field: string, type: string) {
    return this.fieldsByClass(this, field, "PazOrderDeliveryDialog")[type];
  }

  get packageSizeOpt() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
      return { title: `${item}`, value: `${item}` };
    });
  }

  public selectedPackageSize: number | null = null;
  async changePackageSize(size: number) {
    const fullId = this.selectedFulfilment.id;
    const data = { packageSize: size };
    const resp = await updateFullfilment(fullId, data);
    if (!resp || !resp.hasOwnProperty("id")) {
      this.$parent.$refs.toast.show({
        message: "An error occurred, Status hasn't been changed",
        icon: "mdi-close-circle",
        color: "red",
        yPosition: "top",
      });
      return;
    }
    this.selectedPackageSize = size;
    this.$emit("updateList", this.selectedFulfilment.id);
  }

  get hasBatch(){
    return this.orderData?.fulfilments[0]?.batchFulfilment?.id ?? false;
  }

  updateQuantity(value: number, item: IOrderLine) {
    item.newQuantity = value;
    this.quantityWarnMessage(item);
  }

  quantityWarnMessage(item: IOrderLine) {
    if (
      parseInt(item.newQuantity) > item.max ||
      parseInt(item.newQuantity) < 1
    ) {
      this.$parent.$refs.toast.show({
        message: "quantity can't be more than ordered value or negative",
        icon: "mdi-close-circle",
        color: "red",
      });
      item.newQuantity = item.max;
    }
  }

  async createDelivery() {
    const defaultErrorMessage =
      "An error occurred, please contact the administrator";
    this.loading = true;
    let orderLine: { quantity: number; id: any }[] = [];

    if (this.selected.length) {
      this.selected.forEach((item) => {
        orderLine.push({
          id: item.id,
          quantity: item.newQuantity,
        });
      });
    }

    let deliveryPayload = {
      id: this.orderId,
      orderLine,
      transporter: this.selectedTransporter,
      deliverAt: this.deliverAt,
      packageSize: this.packageSize,
    };
    try {
      let response = await postOrderDelivery(deliveryPayload);
      if (response && response.success) {
        this.$parent.$refs.toast.show({
          message: response?.message,
          color: "green",
        });
      } else {
        this.$parent.$refs.toast.show({
          message: response?.response?.data?.message,
          icon: "mdi-close-circle",
          color: "red",
        });
      }
      this.closeDialog();
      this.$emit("order:update");
    } catch (error) {
      this.$parent.$refs.toast.show({
        message: defaultErrorMessage,
        color: "red",
        icon: "mdi-close-circle",
      });
    }
    this.loading = false;
  }

  /**
   * SECTION: Delivery part
   */
  public selectedOrderStatus: string = "";
  async updateDeliveryStatus(value: string) {
    const fullId = this.selectedFulfilment.id;
    const data = { status: value };
    const resp = await updateFullfilment(fullId, data);
    if (!resp || !resp.hasOwnProperty("id")) {
      this.$parent.$refs.toast.show({
        message: "An error occurred, Status hasn't been changed",
        icon: "mdi-close-circle",
        color: "red",
        yPosition: "top",
      });
      return;
    }
    this.$emit("updateList");
  }

  get getFulfilmentStatus(): string {
    return this.selectedFulfilment?.status || "";
  }

  get cFulfilmentStatuses(): any[] {
    if (this.FulfilmentStatuses.fulfilmentStatuses) {
      let statusOfSelectedShipment: string = this.getFulfilmentStatus;

      if (!statusOfSelectedShipment) {
        return [];
      }

      //NOTE: handle custom statuses
      if (
        !this.FulfilmentStatuses.fulfilmentStatuses.hasOwnProperty(
          statusOfSelectedShipment
        )
      ) {
        return [
          ...this.FulfilmentStatuses.fulfilmentStatuses["ERROR"],
          statusOfSelectedShipment,
        ];
      }

      let selectableStatuses: string[] =
        this.FulfilmentStatuses.fulfilmentStatuses[statusOfSelectedShipment];

      if (
        selectableStatuses &&
        selectableStatuses.length !== 0 &&
        !selectableStatuses.includes(statusOfSelectedShipment)
      )
        selectableStatuses.push(statusOfSelectedShipment);

      if (!this.selectedOrderStatus)
        this.selectedOrderStatus = statusOfSelectedShipment;

      if (Array.isArray(selectableStatuses)) {
        return selectableStatuses.map((status: string) => {
          return { status, label: status.replaceAll("_", " ") };
        });
      }
      return [];
    }
  }

  get isShipment() {
    return (
      this.selectedFulfilment && this.selectedFulfilment.hasOwnProperty("id")
    );
  }

  get getPackageSizes() {
    const packArray =
      this.packageSizeItems && Object.values(this.packageSizeItems);

    if (packArray && packArray.length > 0) {
      return packArray.map((p) => {
        if (p.default) this.packageSize = p.label;
        return p;
      });
    }
    return [];
  }

  /* END */

  closeDialog() {
    this.showDialog = false;
  }

  get getBusiness(){
    return this.orderData && this.orderData.customer && this.orderData.customer.business;
  }

  get getShippingAddress() {
    return this.orderData && this.orderData.order.shippingaddress;
  }

  async fetchData() {
    this.mainPreLoading = true;
    this.transports = await getFulfilmentTransports(this.orderId);

    //NOTE: Delivery mode
    if (this.orderId && this.orderId > 0) {
      this.orderData = await getOrderDetails(this.orderId, false,'batchFulfilment');

      if (!this.selectedFulfilment) {

        let orderLine = await getOrderLines({ order: this.orderId });
        this.fulfilment = (await getFulfilment({ order: this.orderId }))[0];
        let fulfilmentsLine: any[] = this.fulfilment
          ? await getFulfilmentOrderLines({ fulfilment: this.fulfilment.id })
          : [];
        this.orderLines = this.preparingOrderLine(orderLine, fulfilmentsLine);
        this.packageSizeItems = await getPackageSizes();
      }
    }

    // NOTE: Shipment mode
    if (this.selectedFulfilment) {
      const fulfilmentLines = await getFulfilmentOrderLines(
        { fulfilment: this.selectedFulfilment.id },
        { expand: "orderLine,product" }
      );
      const statusesResp = await getFulfilmentStatuses();
      if (statusesResp && statusesResp.hasOwnProperty("fulfilmentStatuses"))
        this.FulfilmentStatuses = statusesResp;
      this.headers = this.shipmentHeaders;
      this.orderLines = fulfilmentLines || [];
      this.selectedPackageSize = this.selectedFulfilment.packageSize;
      this.preferredDeliveryDate = formatDateTime(
        this.selectedFulfilment.order.preferredDeliveryDate,
        undefined,
        "YYYY-MM-DD",
        false
      );
    }
    this.mainPreLoading = false;
  }

  async mounted() {
    await this.fetchData();
  }

  async onChangeTransporter(value: string) {

    let id = this.selectedFulfilment?.id;
    if(!id){
      return;
    }
    let rsp = await updateFullfilment(id, {transporter: value})
    if(rsp.transporter == value){
      this.$parent.$refs.toast.show({message: `Transporter updated to '${value}'`});
    }

  }
  async onChangePreferredDate(value: string) {
    await updateOrder(this.selectedFulfilment.order.id, {
      preferredDeliveryDate: value,
    });
  }

  async handleSendShipmentAndNext() {
    const url = `${authentication.userConfig.base.url}/api/v3`;
    await putRequest(
        `${url}/catalog/fulfilments/${this.selectedFulfilment.id}`,
        {
          order: this.selectedFulfilment.order.id,
          status: "PENDING",
        }
    );
    this.$emit("getNextItem");
    this.closeDialog();
  }

  async handleSendShipment() {
    const url = `${authentication.userConfig.base.url}/api/v3`;
    await putRequest(
      `${url}/catalog/fulfilments/${this.selectedFulfilment.id}`,
      {
        order: this.selectedFulfilment.order.id,
        status: "PENDING",
      }
    );
    this.$emit("updateList");
    this.closeDialog();
  }

  get canEditTransporter(){
    return this.hasProfileFlag("fulfilmentManagement.edit.transporter");
  }

  get canEdit() {
    return this.hasProfileFlag("fulfilmentManagement.edit");
  }
}
